import * as React from 'react';
import {GROUP} from '../../../constants/LabelConstants';
import {GroupCommissionCardDeleteState, GroupDeleteProps} from '../../../types/mx/components';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import InputText from '../../../../../common/components/InputText';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import {GLOBAL} from '../../../../constants/LabelConstants';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';

class CardCommissionDeleteView extends React.Component<GroupDeleteProps, GroupCommissionCardDeleteState> {
    constructor(props) {
        super(props);
        this.state = {
            deleteReasonValue: null,
            deleteReasonError: ValidateConstant.ERROR_REQUIRED,
            deleteReasonOther: null,
            deleteReasonOtherError: ValidateConstant.ERROR_REQUIRED,
            showErrors: false
        };
    }

    onPressConfirm(onPressDeleteConfirm) {
        const selectedOther = this.state.deleteReasonValue &&
            this.state.deleteReasonValue.id === GROUP.GROUP_DELETE_REASON_REASSIGN_CARD_ID;
        const hasDeleteReasonOtherError = selectedOther && this.state.deleteReasonOtherError != null;
        if (this.state.deleteReasonError == null && !hasDeleteReasonOtherError) {
            onPressDeleteConfirm(this.state.deleteReasonValue, this.state.deleteReasonOther);
            return;
        }
        this.setState({
            showErrors: true
        });
    }

    renderButton(onPressDeleteConfirm, onPressClose) {
        return <React.Fragment><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>{GROUP.DELETE_GROUP_CANCEL_BUTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={() => this.onPressConfirm(onPressDeleteConfirm)}>
                {GROUP.DELETE_CARD_COMMISSION_CONFIRM_BUTON}</a>
        </React.Fragment>;
    }

    render() {
        const {group, onPressDeleteConfirm, onPressClose, cardCommissionDeleteReasons} = this.props;
        const isReassignCardReasonSelected = this.state.deleteReasonValue &&
            this.state.deleteReasonValue.id === GROUP.GROUP_DELETE_REASON_REASSIGN_CARD_ID;
        return (
            <div className="col-12 p-0">
                <div className="text-justify pt-2">
                    Por favor selecciona un motivo de eliminación de esta tarjeta.
                </div>
                <div className="text-justify pt-4">
                    <SelectSearchComponent
                        id="deleteReason"
                        customClass="no-min-height"
                        required={true}
                        hasError={this.state.showErrors}
                        filter={false}
                        labelError={this.state.deleteReasonError}
                        label={GROUP.GROUP_DELETE_SELECT_REASON}
                        placeholder={GLOBAL.SELECT}
                        data={cardCommissionDeleteReasons}
                        value={this.state.deleteReasonValue}
                        onChange={(value, error) => {
                            this.setState({
                                deleteReasonValue: value,
                                deleteReasonError: error,
                                showErrors: false
                            });
                        }}/>
                </div>
                {isReassignCardReasonSelected &&
                    <div className="text-justify pt-4">
                        <InputText
                            label={GROUP.GROUP_DELETE_REASON_REASSIGN_CARD}
                            id="deleteReasonReassignCard"
                            hasError={this.state.showErrors}
                            maxLength={15}
                            minLength={12}
                            type={InputTextTypes.ALPHA_NUMERIC}
                            labelError={this.state.deleteReasonOtherError}
                            value={this.state.deleteReasonOther}
                            onChange={(value, error) => {
                                this.setState({
                                    deleteReasonOther: value,
                                    deleteReasonOtherError: error,
                                    showErrors: false
                                });
                            }}/>
                    </div>
                }
                <div className="text-justify py-3">
                    Esta opción no se puede deshacer.
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressDeleteConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default CardCommissionDeleteView;
